import { Navigate, useLocation } from "react-router-dom";
import React, { useContext } from "react";

import { AppRoutes } from "../../constants/appRoutes";
import { AuthContext } from "../../context/contextProvider";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LocalGasStationIcon from "@mui/icons-material/LocalGasStation";
import WorkOrdersPage from "../workOrders/WorkOrdersPage";

const breadcrumbs = [
  {
    IconComponent: DashboardIcon,
    title: "Dashboard",
    to: AppRoutes.dashboard,
  },
  {
    IconComponent: LocalGasStationIcon,
    title: "Delivery Orders",
  },
];

const DeliveryOrdersActivePage = (props) => {
  const { state } = useLocation();
  const { branchModules } = useContext(AuthContext);

  if (!branchModules?.workOrders)
    return (
      <Navigate
        to={{
          pathname: AppRoutes.forbidden,
        }}
      />
    );

  return (
    <WorkOrdersPage
      breadcrumbs={breadcrumbs}
      dashboardType={state?.dashboardType}
      directDrops={false}
      title="Delivery Orders - Active"
    />
  );
};

export default DeliveryOrdersActivePage;
